module.exports = __webpack_public_path__ + "img/share.6ceeac40.png";